import { render, staticRenderFns } from "./ALFile.vue?vue&type=template&id=63a897d0"
import script from "./ALFile.vue?vue&type=script&lang=js"
export * from "./ALFile.vue?vue&type=script&lang=js"
import style0 from "./ALFile.vue?vue&type=style&index=0&id=63a897d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports